module.exports = __webpack_public_path__ + "img/29.5b3664ff.jpg";